(() => {
  'use strict';
  const activeRequests = new WeakMap();
  const refresh = async root => {
    if (!root.isConnected || !Number(root.dataset.cartItems) || activeRequests.has(root)) return;
    const sectionId = root.dataset.cartSection;
    if (!sectionId) return;
    const controller = new AbortController();
    activeRequests.set(root, controller);
    root.dataset.pricingSync = 'refreshing';
    try {
      const routes = window.HRTheme?.routes || {};
      const endpoint = (routes.cartUpdate || (routes.root || '/') + 'cart/update').replace(/\/$/, '') + '.js';
      const response = await fetch(endpoint, {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: {}, sections: [sectionId], sections_url: window.location.pathname })
      });
      if (!response.ok) throw new Error('Cart pricing unavailable');
      const result = await response.json();
      const html = result.sections?.[sectionId];
      if (!html || !root.isConnected) throw new Error('Cart section unavailable');
      const section = new DOMParser().parseFromString(html, 'text/html');
      const nextPricing = section.querySelector('[data-cart-pricing]');
      const currentPricing = root.querySelector('[data-cart-pricing]');
      if (!nextPricing || !currentPricing) throw new Error('Cart totals unavailable');
      currentPricing.replaceWith(nextPricing);
      const prices = [...root.querySelectorAll('[data-cart-price-key]')];
      section.querySelectorAll('[data-cart-price-key]').forEach(next => {
        const current = prices.find(price => price.dataset.cartPriceKey === next.dataset.cartPriceKey) || prices.find(price => price.dataset.cartPriceVariant === next.dataset.cartPriceVariant && price.dataset.cartPriceProperties === next.dataset.cartPriceProperties);
        current?.replaceWith(next);
      });
      root.dataset.pricingSync = 'fresh';
    } catch (error) {
      if (error.name !== 'AbortError') root.dataset.pricingSync = 'unavailable';
    } finally {
      activeRequests.delete(root);
    }
  };
  const init = root => {
    if (root.dataset.pricingReady) return;
    root.dataset.pricingReady = 'true';
    root.querySelector('form')?.addEventListener('submit', () => activeRequests.get(root)?.abort());
    refresh(root);
  };
  const start = scope => {
    if (scope.matches?.('[data-cart-pricing-root]')) init(scope);
    scope.querySelectorAll?.('[data-cart-pricing-root]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document)); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  window.addEventListener('pageshow', event => {
    if (event.persisted) document.querySelectorAll('[data-cart-pricing-root]').forEach(refresh);
  });
})();
